import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { LensLineageSubplaceRouter, LensLineageSubplaceRouterProps } from './LensLineageSubplace';

export type EmbeddableLensSubplaceProps = VizPortalDataCatalogProviderProps & LensLineageSubplaceRouterProps;

export const EmbeddableLensSubplaceWithoutRouter: React.FC<EmbeddableLensSubplaceProps> = props => {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <LensLineageSubplaceRouter vizportalUrlId={props.vizportalUrlId} />
    </LineageBrowserDataCatalogProvider>
  );
};
